module.exports = __webpack_public_path__ + "img/808-67be08.png";